import React from 'react';
import { useController } from 'react-hook-form';

// tools
import renderHtmlContent from '../../../../helpers/renderHtmlContent';

// components
import FormFieldError from '../FormFieldError';
import FormFieldLabel from '../FormFieldLabel';
import FormFieldDescription from '../FormFieldDescription';

const Select = ({ name, control, rules, label, options = [], description, ...props }) => {
    const {
        field,
        fieldState: { error }
    } = useController({
        name,
        control,
        rules
    });

    return (
        <div className="FormField FormField--select">
            <FormFieldLabel label={label} name={name} rules={rules}/>
            <select
                {...field}
                {...props}
                id={name}
            >
                {options.map((option) => (
                    <option key={option.value} value={option.value}>
                        {renderHtmlContent(option.label)}
                    </option>
                ))}
            </select>
            {error ? (
                <FormFieldError error={error} />
            ) : (
                <FormFieldDescription description={description} />
            )}
        </div>
    );
};

export default Select;